import React from 'react';
import NumberFormat from 'react-number-format';

const OrderHelper = {
    /**
     * round number to fixed 2
     */
    roundNumber: function (number) {
        if (number === null || number === '') {
            return '';
        }
        return Math.round(number * 100) / 100;
    }
};
/**
 * helper for item
 */
OrderHelper.item = {
    /**
     * get origin price of item, = price_org
     */
    priceUnit: function (item) {
        // let p = typeof item.UnitPriceFL === 'string' ? item.UnitPriceFL.trim() : item.UnitPriceFL;
        let p = typeof item.OriginalPriceFL === 'string' ? item.OriginalPriceFL.trim() : item.OriginalPriceFL;
        return OrderHelper.roundNumber(p);
    },
    /**
     * get discount price of item, = price adj
     */
    priceAdjustment: function (item) {
        return OrderHelper.roundNumber(item.AdjustmentValueFL);
    },
    /**
     * get final price of item, old version is item_value
     */
    priceAdjusted: function (item) {
        return OrderHelper.roundNumber(this.priceUnit(item) - this.priceAdjustment(item));
        // let p = typeof item.AdjustedValueFL === 'string' ? item.AdjustedValueFL.trim() : item.AdjustedValueFL;
        // return (p === '' || p === null) ? this.priceUnit(item) : this.roundNumber(p);
    },
    /**
     * check item is discount
     */
    priceIsDiscount: function (item) {
        return !!this.priceAdjustment(item);
    },
    /**
     * titlle tooltip for discount item
     *
     * @param float origin price origin
     * @param float discount price discount
     * @param float final price final
     */
    titleDiscount: function (origin, discount, final) {
        if (typeof origin === 'object') {
            discount = this.priceAdjustment(origin);
            final = this.priceAdjusted(origin);
            origin = this.priceUnit(origin);
        }
        discount = -OrderHelper.roundNumber(discount);
        final = OrderHelper.roundNumber(final);
        origin = OrderHelper.roundNumber(origin);
        return (
            <div className="title-discount">
                <p className="td-item">
                    <span className="td-label">Original</span>
                    <span className="price-number">{this.formatPrice(origin)}</span>
                </p>
                <p className={"td-item" + (discount < 0 ? ' price-neg' : '')}>
                    <span className="td-label">Adjustment</span>
                    <span className="price-number">{this.formatPrice(discount)}</span>
                </p>
                <hr />
                <p className="td-item">
                    <span className="td-label">Adjusted</span>
                    <span className="price-number">{this.formatPrice(final)}</span>
                </p>
            </div>
        );
    },
    /**
     * format price item
     */
    formatPrice: function (price) {
        return (
            <NumberFormat value={price} displayType={'text'} thousandSeparator={true} />
        )
    },
};

export default OrderHelper;



// WEBPACK FOOTER //
// ./src/services/orderHelper.js